import TileWMS from 'ol/source/TileWMS';
import {
  DEFAULT_LIGHT_CONDITION, LAYERS_PARAM, LIGHT_CONDITION_PARAM, DEFAULT_WMS_VERSION, WMS_VERSION_PARAM, DATABASE_VERSION_PARAM,
} from './GeomodSourceUtils';
import { LAYERS_PARAMETERS_UPDATED_EVENT_TYPE } from '../utils/events.js';
import { TileLayerCacheStrategy } from '../utils/cache.js';
// import { tileLoader } from '../utils/httpRequest';

/**
 * @typedef {Object} GeomodTileWMSOptions
 * @property {string} name The layer name.
 * @property {string} url The url endpoint to request.
 * @property {string} [light] The initial light condition of the layer. Default: DAY
 * @property {string} [version] The WMS protocole version. Default: 1.3.0
 * @property {TileLayerCacheStrategyOptions} [cache]  Cache strategy settings
 * @property {Map<string,string>} [extraParameters] The extra parameters for the request exemple: AIS_SHOW_TRACE=false.
 */



/**
 * The Geomod WMS tile source.
 * @extends {TileWMS}
 */
export default class GeomodTileWMS extends TileWMS {
  /**
     * @constructor
     * @param {GeomodTileWMSOptions} options The object options.
     */
  constructor(options = {}) {
    let extraParametersOptions;
    if (options.extraParameters) {
      extraParametersOptions = {};
      const extraParameters = JSON.parse(localStorage.getItem('layerExtraParameters')) || {};
      for (const key of options.extraParameters) {
        extraParametersOptions[key] = extraParameters[key];
      }
    }

    const superParams = {
      interpolate: false,
      url: options.url,
      params: {
        ...extraParametersOptions,
        [LAYERS_PARAM]: options.name,
        [LIGHT_CONDITION_PARAM]: options.light || DEFAULT_LIGHT_CONDITION,
        [WMS_VERSION_PARAM]: DEFAULT_WMS_VERSION,
        token: localStorage.getItem('token')
      },
      tileLoadFunction: function(tile, src) {
        const url = new URL(src)
        if (options.name.includes('benc')) url.searchParams.set('_cache', Date.now())
        tile.getImage().src = url.toString()
      }
    }

    const requestOptions = localStorage.getItem('requestOptions')
    if (requestOptions && requestOptions !== 'null' && Object.keys(JSON.parse(requestOptions)).length > 0) {
      superParams.params = { ...superParams.params, ...JSON.parse(requestOptions) };
    }

    super(superParams);

    let previousParameterchange;

    if (extraParametersOptions) {
      document.addEventListener(LAYERS_PARAMETERS_UPDATED_EVENT_TYPE, (e) => {
        const updateParams = {};
        const extraParameters = JSON.parse(localStorage.getItem('layerExtraParameters')) || {};
        for (const key in extraParametersOptions) {
          if (e.detail.parameters.includes(key)) {
            updateParams[key] = extraParameters[key];
          }
        }
        if (Object.keys(updateParams).length > 0) {
          if (previousParameterchange) {
            clearTimeout(previousParameterchange);
          } else {
            this.updateParams(updateParams);
            this.cacheStrategy.run(this);
          }
          previousParameterchange = setTimeout(() => {
            this.updateParams(updateParams);
            previousParameterchange = undefined;
            this.cacheStrategy.run(this);
          }, 200);
        }
      })
    }

    /**
         * The source tag
         * @private
         * @type {string}
         */
    this.tag_ = options.filter;

    /**
         * The cache strategy used by the layer
         * @type {TileLayerCacheStrategy}
         */
    this.cacheStrategy = new TileLayerCacheStrategy(options.cache);
  }

  /**
     * Get the source tag.
     * @return {string} The source tag.
     */
  getTag() {
    return this.tag_;
  }

  /**
     * @inheritdoc
     */
  updateParams(params) {
    super.updateParams(params);
    if (params[DATABASE_VERSION_PARAM]) {
      this.cacheStrategy.run(this);
    }
  }
}
